import { gql } from "@apollo/client";

export const LOCKER_TYPES_FOR_STORAGE_TIME_LIMITS = gql`
  {
    lockerTypes {
      lockerTypeId
      lockerType
    }
  }
`;

export const STORAGE_TIME_LIMITS = gql`
  query ($operatorId: ID!, $lockerTypeId: ID!) {
    lockerLimit(operatorId: $operatorId, lockerTypeId: $lockerTypeId) {
      storageTakebackLimit
      storagePulloutLimit
      lockerLimitId
    }
  }
`;

export const UPDATE_STORAGE_TIME_LIMITS = gql`
  mutation (
    $lockerLimitId: Int!
    $lockerTypeId: Int!
    $operatorId: Int!
    $storagePulloutLimit: Int!
    $storageTakebackLimit: Int!
  ) {
    updateLockerLimit(
      lockerLimitId: $lockerLimitId
      lockerTypeId: $lockerTypeId
      operatorId: $operatorId
      storagePulloutLimit: $storagePulloutLimit
      storageTakebackLimit: $storageTakebackLimit
    ) {
      lockerLimit {
        lockerLimitId
      }
    }
  }
`;
